import * as React from "react";
import type { SVGProps } from "react";
const SvgOverageExceeded = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={38}
    height={4}
    fill="none"
    viewBox="0 0 38 4" {...props}
  >
    <path stroke="#D6DBE7" strokeWidth={3} d="M0 2h8.5M14.5 2H23M29 2h8.5" />
  </svg>
);
export default SvgOverageExceeded;
